<div class="invisible-layer windows-layer">
  <ng-container *ngFor="let window of allWindows; trackBy: windowsId">
    <app-window
      [hidden]="window.isMinimized()"
      [id]="window.id" 
      [title]="window.title"
      [content]="window.content"
      [overflow]="window.overflow"
      [hasFocus]="window.hasFocus()"
      [isMaximized]="window.isMaximized()"
      [positionLocked]="window.isMaximized()"
      style="z-index:{{getZ(window)}};"
      (mousedown)="focus(window)">
    </app-window>
  </ng-container>
</div>